import { ReactNode, forwardRef, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  hoverable?: boolean;
  onClick?: () => void;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = "", hoverable = true, onClick, ...props }, ref) => {
    const baseClasses = [
      "bg-white rounded-3xl border border-gray-200",
      "flex flex-col overflow-hidden",
      "transition-all duration-300 ease-out",
      "shadow-[0_16px_40px_20px_rgba(112,144,176,0.05)]",
    ];

    const hoverClasses = hoverable
      ? [
          "hover:shadow-[0_20px_50px_25px_rgba(112,144,176,0.12)]",
          "hover:-translate-y-1",
        ]
      : [];

    const clickableClasses = onClick ? ["cursor-pointer"] : [];

    const allClasses = [
      ...baseClasses,
      ...hoverClasses,
      ...clickableClasses,
      className.trim(),
    ]
      .filter(Boolean)
      .join(" ");

    if (onClick) {
      return (
        <button
          type="button"
          onClick={onClick}
          className={allClasses}
          {...(props as HTMLAttributes<HTMLButtonElement>)}
        >
          {children}
        </button>
      );
    }

    return (
      <div ref={ref} className={allClasses} {...props}>
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";
